var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"top-progress"},[_c('v-progress-linear',{staticClass:"ma-0",staticStyle:{"position":"fixed"},attrs:{"indeterminate":"","color":"primary lighten-3","height":"5"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }